import styled from 'styled-components'

import { More } from './More'
import { NewsRelease } from './NewsRelease'
import { RecentlyBlogList } from './RecentlyBlogList'
import { ImageTitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'

import type { Blog } from '@/types/blog'
import type { NewsRelease as NewsReleaseType } from '@/types/newsRelease'

type NewsPageProps = {
  newsRelease: readonly NewsReleaseType[]
  blogList: readonly Blog[]
}

export const NewsPage = ({ newsRelease, blogList }: NewsPageProps) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: 'ニュースルーム', path: '' },
  ]

  return (
    <>
      <Head
        title="ニュースルーム"
        description="トライアルホールディングスの広報リソースをご覧いただけます。"
        ogp={{ url: 'news/' }}
      />
      <ImageTitleLayout
        title="Newsroom"
        subTitle="ニュースルーム"
        imgUrl="/images/top-news.webp"
        breadCrumbs={breadCrumbs}
        isRequiredBackground
      >
        <NewsRoom>
          <NewsRelease newsList={newsRelease} />
          <RecentlyBlogList blogList={blogList} />
          <More />
        </NewsRoom>
      </ImageTitleLayout>
    </>
  )
}

const NewsRoom = styled.div`
  width: 1040px;
  margin: 0 auto;
  padding: 96px 0 130px;
  display: flex;
  flex-direction: column;
  gap: 140px;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 40px 20px 80px;
    gap: 80px;
  }
`
